import { Radio as RadioPrimitive } from "@base-ui/react/radio";
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group";

import { focusStyles } from "@beweegbaas/ui/lib/focus-styles";
import { cnState } from "@beweegbaas/ui/lib/utils";
import { IconCircle } from "@tabler/icons-react";

function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props) {
  return (
    <RadioGroupPrimitive
      data-slot="radio-group"
      className={cnState("grid w-full gap-3", className)}
      {...props}
    />
  );
}

function RadioGroupItem({ className, ...props }: RadioPrimitive.Root.Props) {
  return (
    <RadioPrimitive.Root
      data-slot="radio-group-item"
      className={cnState(
        [
          `indicator border-input text-primary dark:bg-input/30
          data-checked:text-primary-foreground data-checked:border-primary
          aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40
          aria-invalid:border-destructive dark:aria-invalid:border-destructive/50
          group/radio-group-item peer
          relative flex aspect-square size-4
          shrink-0 rounded-full border shadow-xs after:absolute
          after:-inset-x-3 after:-inset-y-2 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-[3px]
          data-checked:bg-linear-to-b data-checked:from-blue-500 data-checked:to-blue-600`,
          focusStyles,
        ],
        className,
      )}
      {...props}
    >
      <RadioPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="group-aria-invalid/radio-group-item:text-destructive
          text-primary flex size-4 items-center justify-center"
      >
        <IconCircle
          className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2
            -translate-y-1/2 fill-white"
        />
      </RadioPrimitive.Indicator>
    </RadioPrimitive.Root>
  );
}

// Export the primitives for advanced use cases
export { RadioGroup, RadioGroupItem, RadioGroupPrimitive, RadioPrimitive };
